import { JokerFieldsCountByType, JokerFieldShortNamePrefix } from '../config/joker';
import { v4 as uuidv4 } from 'uuid';

export const normalizeJokerFields = (data, type, isRowMode) => {
  const config = JokerFieldsCountByType[type];
  if (!config) return data;

  const result = data.map((item) => ({
    ...item,
    visOrder: item.jokerGroups?.[0]?.visOrder ?? null,
  }));

  const typesToFill = isRowMode ? config?.ROWS ?? {} : config;

  const orderMap = {};
  let orderIndex = 0;

  Object.entries(typesToFill).forEach(([shortType, count]) => {
    if (shortType === 'ROWS') return;

    const prefix = JokerFieldShortNamePrefix[shortType];

    for (let i = 1; i <= count; i++) {
      const fieldName = `${prefix}${i}`;

      orderMap[fieldName] = orderIndex++;

      const exists = result.some((f) => f.field === fieldName);
      if (!exists) {
        result.push({
          id: uuidv4(),
          field: fieldName,
          name: '',
          isRow: isRowMode ? true : false,
          isNew: true,
          visOrder: null,
          jokerValues: [],
          jokerGroups: [],
        });
      }
    }
  });

  result.sort((a, b) => orderMap[a.field] - orderMap[b.field]);

  return result;
};
